import { firebase } from './api/firebase'
const db = firebase.database()
const environment = require('@/environments/production')

export const contact = {
  namespaced: true,
  state: {},
  actions: {
    sendMessage: (context, payload) => {
      let message = Object.assign({}, payload)
      message.timestamp = new Date().getTime()
      message.message += `\n${context.rootState.user.uid}:${context.rootState.user.groupId}\n${new Date().toLocaleString()}`
      return db.ref(environment.schema.contactUs).push({
        email: message.email,
        emailBack: message.emailBack,
        message: message.message,
        name: message.fullName,
        subject: message.subject,
        timestamp: message.timestamp
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contact.js